import { RevisionCommentPlacement } from "~/types/enums/RevisionCommentPlacement.enum";
import { usePopulateAnnotationMaps } from "../wordGenerator/usePopulateAnnotationMaps";
import { useClipboardChecklistGenerator } from "./useClipboardChecklistGenerator";
import { useClipboardParagraphGenerator } from "./useClipboardParagraphGenerator";

export const useClipboardHTMLGenerator = async (
  submittedDocument: SubmittedDocument,
  revision: Revision,
  checklist: Checklist | undefined,
  allCriteria: ChecklistCriteria[] | undefined,
  wordChecklistCells: WordChecklistCells | undefined,
  paragraphs: Paragraphs,
  annotations: RevisionAnnotations,
  totalEarnedScore: number | undefined,
  earnedScore: number | undefined,
  commentColor: number[]
): Promise<HTMLDivElement> => {
  const container = document.createElement("div");

  const revisionCommentPlacement =
    revision.commentPlacement ?? RevisionCommentPlacement.AfterDocument;

  paragraphs = useTrimParagraphs(paragraphs);

  const { annotationMap, annotationParagraphMap, endLineAnnotations } =
    usePopulateAnnotationMaps(annotations);

  if (
    checklist &&
    wordChecklistCells &&
    allCriteria &&
    totalEarnedScore != undefined &&
    earnedScore != undefined
  ) {
    const checklistTable = useClipboardChecklistGenerator(
      submittedDocument,
      checklist,
      wordChecklistCells,
      allCriteria,
      totalEarnedScore,
      earnedScore,
      commentColor
    );

    if (checklistTable) {
      container.appendChild(checklistTable);
    }
  }

  // Add a page break
  const pageBreakSpan = document.createElement("span");
  pageBreakSpan.innerText = "\n\n";
  container.appendChild(pageBreakSpan);

  if (
    revision.commentObject &&
    revisionCommentPlacement == RevisionCommentPlacement.BeforeDocument
  ) {
    const lines = useConvertQuillDeltaToSpans(
      revision.commentObject,
      12,
      useRGBToHex(commentColor)
    ).flat();

    const lineBreak = document.createElement("span");
    lineBreak.innerText = "\n";
    container.appendChild(lineBreak);

    for (const line of lines) {
      container.appendChild(line);
    }
  }

  let previousParagraphCollectionRef = undefined;

  for (const paragraph of paragraphs) {
    const paragraphData = useClipboardParagraphGenerator(
      paragraph,
      annotationMap,
      annotationParagraphMap,
      endLineAnnotations,
      previousParagraphCollectionRef,
      commentColor,
      false
    );

    previousParagraphCollectionRef = paragraph.collectionRef;

    container.appendChild(paragraphData);
  }

  if (
    revision.commentObject &&
    revisionCommentPlacement == RevisionCommentPlacement.AfterDocument
  ) {
    const lines = useConvertQuillDeltaToSpans(
      revision.commentObject,
      12,
      useRGBToHex(commentColor)
    ).flat();

    const lineBreak = document.createElement("span");
    lineBreak.innerText = "\n";
    container.appendChild(lineBreak);

    for (const line of lines) {
      container.appendChild(line);
    }
  }

  return container;
};
